<template lang="pug">
  #contract
    header-for-top-page(:client_no="client_no", :firm_name="firm_name")
    header-menu(:neo_contract_status="neo_contract_status", :chat_contract_status="chat_contract_status", :isLoadingHeader="isLoadingHeader", :sales_channel="sales_channel", :has_special_priced_item="has_special_priced_item", :display_e_invoice_flg="display_e_invoice_flg")
    router-view.form-box.mx-auto(:sales_channel="sales_channel", :has_special_priced_item="has_special_priced_item", :contract_info="contract_info", :order_info="order_info", :common_info="common_info")
</template>

<script>
import HeaderForTopPage from "@/components/supportSite/HeaderForTopPage";
import HeaderMenu from "@/components/supportSite/HeaderMenu";

import Api from '@/repositories/api'
const HeaderInfoRepository = Api.get('c205HeaderInfo')

export default {
  name: "Index",
  components: {
    HeaderForTopPage,
    HeaderMenu,
  },
  data() {
    return {
      // お客様番号
      client_no: '- -',
      // 会社名
      firm_name: '- -',
      // 販売種別
      sales_channel: '',
      // 優待価格商品保有フラグ
      has_special_priced_item: '',
      // 電子請求システムの表示フラグ
      display_e_invoice_flg: false,
      // NEOの契約情報ステータス
      neo_contract_status: null,
      // ChatLuckの契約情報ステータス
      chat_contract_status: null,
      // ローディングのステータス
      isLoadingHeader: false,
      // 契約情報
      contract_info: {
        light_user: '',
        standard_user: '',
        premium_user: '',
        chatplus_user: '',
        neo: {
          neo_user: '',
          app_suite_user: '',
          app_suite_user_old: '',
          web_conferencing: '',
          cloud_db_user: '',
          option: {
            room_mgr: false,
            expense_settlement: false,
            clouza: {
              user: '',
              clouza_company: '',
              paid_leave_option: false
            },
            disk: {
              disk_size: '',
              disk_size_old: ''
            },
            sync: {
              user: ''
            },
            dn_drive: {
              disk_size: ''
            }
          },
          security: {
            basic: {
              basic_id: '',
              basic_password: '',
              basic_except_ip: ''
            },
            connect_permit_ip: '',
            secure: {
              secure_browser_terminal: '',
              secure_browser_device: '',
              secure_except_ip: '',
              secure_browser_certificate_action: '04',
              secure_browser_re_create: '',
              secure_browser_delete_certificate: '',
            },
            client: {
              device: '',
              cert_except_ip: ''
            }
          },
          mail: {
            arena: {
              wa_domain: '',
              account: ''
            },
            cyber: {
              account: '',
              mailbox: '00',
              options: [],
              keep: '00'
            }
          },
          mail_security: {
            mailgates: {
              mailgates_domain: '',
              account: '',
              options: []
            }
          },
        },
        chat: {
          chat_user: '',
          option: {
            disk: {
              disk_size: ''
            }
          },
          security: {
            basic: {
              basic_id: '',
              basic_password: '',
              basic_except_ip: ''
            },
            connect_permit_ip: ''
          },
        },
      },

      // 注文情報
      order_info: {
        light_user: '',
        standard_user: '',
        premium_user: '',
        chatplus_user: '',
        neo: {
          neo_user: '',
          app_suite_user: '',
          app_suite_user_old: '',
          web_conferencing: '',
          cloud_db_user: '',
          option: {
            room_mgr: false,
            expense_settlement: false,
            clouza: {
              user: '',
              clouza_company: '',
              paid_leave_option: false
            },
            disk: {
              disk_size: '',
              disk_size_old: ''
            },
            sync: {
              user: ''
            },
            dn_drive: {
              disk_size: ''
            }
          },
          security: {
            basic: {
              basic_id: '',
              basic_password: '',
              basic_except_ip: ''
            },
            connect_permit_ip: '',
            secure: {
              secure_browser_terminal: '',
              secure_browser_device: '',
              secure_except_ip: '',
              secure_browser_certificate_action: '04',
              secure_browser_re_create: '',
              secure_browser_delete_certificate: '',
            },
            client: {
              device: '',
              cert_except_ip: ''
            }
          },
          mail: {
            arena: {
              wa_domain: '',
              account: ''
            },
            cyber: {
              account: '',
              mailbox: '00',
              options: [],
              keep: '00'
            }
          },
          mail_security: {
            mailgates: {
              mailgates_domain: '',
              account: '',
              options: []
            }
          },
        },
        chat: {
          chat_user: '',
          option: {
            disk: {
              disk_size: ''
            }
          },
          security: {
            basic: {
              basic_id: '',
              basic_password: '',
              basic_except_ip: ''
            },
            connect_permit_ip: ''
          },
        },
      },
      common_info: {
        // 契約番号
        contract_no: null,
        // 変更対象製品
        target_product: [],
        // 変更希望日
        opening_date: null,
        // 見積番号
        estimate_no: null,
        // 注文備考
        order_remarks: null,
        // Nヶ月後の日付リスト
        offset_date_list: [],
      }
    }
  },
  methods: {
    setHeader() {
      // システムエラー画面の場合は何もしない
      if (this.$route.name.includes('SystemError') === false) {
        // 読み込み中
        this.isLoadingHeader = true;
        // ヘッダー情報を初期化する
        this.client_no = '- -'
        this.firm_name = '- -'

        // 画面表示前共通処理を実行する
        HeaderInfoRepository.get()
          .then((response) => {
            // NEO
            this.neo_contract_status = response.data.common.neo.contract === true ? response.data.common.neo.contract_status : false

            // chat
            this.chat_contract_status = response.data.common.chat.contract === true ? response.data.common.chat.contract_status : false

            // 顧客番号を取得
            this.client_no = response.data.common.client.client_no
            // 会社名を取得
            this.firm_name = response.data.common.client.firm_name
            // 販売種別を取得
            this.sales_channel = response.data.common.client.sales_channel
            // 優待価格商品保有フラグを取得
            this.has_special_priced_item = response.data.common.client.has_special_priced_item
            // 電子請求システムの表示フラグを取得
            this.display_e_invoice_flg = response.data.common.client.is_e_invoice

            // ローカルストレージに顧客番号を保存する
            localStorage.setItem('client_no', this.client_no)

            // NEOがサービス中でない場合
            if (response.data.common.neo.contract_status !== '4') {
              // ローカルストレージからキー削除
              localStorage.removeItem('neo_domain_name')
            }
            // chatがサービス中でない場合
            if (response.data.common.chat.contract_status !== '4') {
              // ローカルストレージからキー削除
              localStorage.removeItem('chat_domain_name')
            }
          })
          .catch((error) => {
            // 未ログインの場合を除くエラーの場合はシステムエラーとする
            if (error.response.status !== 401) {
              this.$router.push({
                name: "SupportSystemError",
                params: {
                  error_msg: '画面表示処理'
                }
              })
            }
            // セッションの期限が切れている場合はログイン画面に遷移する
            this.moveToLoginPage()
          })
          .finally(() => [
            // 読み込み完了
            this.isLoadingHeader = false
          ])
      }
    }
  },
  created() {
    // 最初に画面表示前共通処理を実行する
    this.setHeader()
  },
  watch: {
    // 画面遷移の度に画面表示前共通処理を実行する
    $route: function () {
      this.setHeader()
    }
  },
}
</script>

<style scoped>
.form-box {
  max-width: 1200px;
}
</style>
